import { Chip, Select, styled } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PriorityEnum } from "components/Status/ChipInfo/chipPriority.interface"

const getColor = (color: number, theme: any) => {
  switch (color) {
    case PriorityEnum.Low:
      return {
        backgroundColor: theme.palette.green[200],
        textColor: theme.palette.success[700]
      }
    case PriorityEnum.Medium:
      return {
        backgroundColor: theme.palette.warning.light,
        textColor: theme.palette.warning[500]
      }
    case PriorityEnum.High:
      return {
        backgroundColor: theme.palette.error.light,
        textColor: theme.palette.error[500]
      }
    case PriorityEnum.None:
      return {
        backgroundColor: theme.palette.default.light,
        textColor: theme.palette.default[600]
      }
    case PriorityEnum.DrivingBan:
      return {
        backgroundColor: theme.palette.error.light,
        textColor: theme.palette.error[500]
      }
    default:
      return {
        backgroundColor: theme.palette.default.light,
        textColor: theme.palette.default[600]
      }
  }
}

export const StyledChipSelect = styled(Select)<{ initialValue: number }>(({ theme, initialValue }) => ({
  borderRadius: 100,
  width: "100%",
  backgroundColor: getColor(initialValue, theme).backgroundColor,
  color: getColor(initialValue, theme).textColor,
  fontSize: "12px",
  fontWeight: 500,
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },
  "& .MuiSvgIcon-root": {
    color: getColor(initialValue, theme).textColor
  },
  "& .MuiSelect-select": {
    paddingTop: "7.5px",
    paddingBottom: "7.5px"
  }
}))

export const StyledChip = styled(Chip)<{ chipColor: string, backgroundColor: string }>(({ chipColor, backgroundColor }) => ({
  display: "inline-flex",
  justifyContent: "flex-start",
  borderColor: chipColor,
  backgroundColor: backgroundColor || "transparent",
  borderRadius: "4px",
  paddingRight: "20px",
  fontWeight: "500",
  "& .MuiChip-label": {
    paddingRight: "8px !important"
  }
}))

export const StyledSelect = styled(Select)<{ chipColor: string, backgroundColor: string }>(({ chipColor, backgroundColor }) => ({
  padding: 0,
  backgroundColor: backgroundColor || "transparent",
  "& .MuiSelect-select": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0 !important"
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none"
  },
  "& .MuiSvgIcon-root": {
    color: chipColor,
  }
}))

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)({
  marginLeft: "8px !important"
})